import {
  type Appointment,
  type ExtendedAppointment,
  useOpportunityAppointments,
} from "@repo/api";

import { isActiveStatus } from "./utils/isActiveStatus";

export const useGrouppedAppointments = (opportunityId?: number) => {
  const { data: appointments, isValidating: isValidatingAppointments } =
    useOpportunityAppointments(opportunityId);

  return {
    ...groupAppointments([...(appointments ?? [])]),
    isValidating: isValidatingAppointments,
  };
};

export const groupAppointments = (
  appointments: Appointment[] | undefined = []
) => {
  const sortedAppointments: ExtendedAppointment[] = appointments
    .sort((a, b) => a.timeWindowStartTime.localeCompare(b.timeWindowStartTime))
    .map((appt, index) => ({ ...appt, ...{ number: index + 1 } }));

  const lastBooked = appointments.sort((a, b) =>
    (b.bookingTime ?? b.timeWindowStartTime).localeCompare(
      a.bookingTime ?? a.timeWindowStartTime
    )
  )?.[0];

  const upcomingAppointments = sortedAppointments
    .filter((a) => isActiveStatus(a.appointmentStatus))
    .map((appt, index) => {
      if (index === 0) {
        return { ...appt, firstUpcoming: true };
      }
      return appt;
    });

  const upcomingIds = upcomingAppointments.map((appt) => appt.appointmentId);
  const rest = sortedAppointments.filter(
    (appt) => !upcomingIds.includes(appt.appointmentId)
  );

  return {
    all: sortedAppointments,
    upcoming: upcomingAppointments,
    completed: rest,
    latest: upcomingAppointments[0],
    lastBooked,
  };
};
